import { IIndicatorRepository, IndicatorEntity, LayerEntity, LayerTypeEnum, ResponseValueObject } from '@gishub/domain'

export class IndicatorRepository implements IIndicatorRepository {
  async getIndicators(): Promise<ResponseValueObject<IndicatorEntity[]>> {
    return new ResponseValueObject(true, [
      {
        id: 'predios-catastrales',
        name: 'Predios Catastrales',
        description: 'Distribución de predios catastrales y rurales registrados en el territorio nacional.',
        chartType: 'bar',
        layer: new LayerEntity({
          name: 'Predios catastrales / rurales',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://georural.midagri.gob.pe/geoservicios/rest/services/servicios_ogc/Catastro_Rural/MapServer/0',
          queryFields: ['id_dist'],
          categoryField: 'id_dist',
        }),
      },
      {
        id: 'comunidades-campesinas',
        name: 'Comunidades Campesinas',
        description: 'Distribución de comunidades campesinas reconocidas y registradas por departamento.',
        chartType: 'bar',
        layer: new LayerEntity({
          name: 'Comunidades campesinas',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://georural.midagri.gob.pe/geoservicios/rest/services/servicios_ogc/Catastro_Rural/MapServer/1',
          queryFields: ['nom_dpto'],
          categoryField: 'estado',
        }),
      },
      {
        id: 'comunidades-nativas',
        name: 'Comunidades Nativas',
        description: 'Distribución de comunidades nativas tituladas y registradas por departamento.',
        chartType: 'bar',
        layer: new LayerEntity({
          name: 'Comunidades nativas',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://georural.midagri.gob.pe/geoservicios/rest/services/servicios_ogc/Catastro_Rural/MapServer/2',
          queryFields: ['nom_dpto'],
          categoryField: 'etnia',
        }),
      },
      {
        id: 'centros-poblados',
        name: 'Centros Poblados',
        description: 'Clasificación de centros poblados según su categoría (ciudad, pueblo, caserío, etc.).',
        chartType: 'pie',
        layer: new LayerEntity({
          name: 'Centros poblados',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://www.idep.gob.pe/geoportal/rest/services/DATOS_GEOESPACIALES/CENTROS_POBLADOS/MapServer/3',
          categoryField: 'CATEGORIA',
          queryFields: ['DEP'],
        }),
      },
      {
        id: 'areas-naturales-protegidas',
        name: 'Áreas Naturales Protegidas',
        description: 'Distribución de las ANP según su categoría de conservación (Parque Nacional, Reserva Nacional, etc.).',
        chartType: 'donut',
        layer: new LayerEntity({
          name: 'Áreas naturales protegidas',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://geoservicios.sernanp.gob.pe/arcgis/rest/services/sernanp_visor/servicio_descarga/MapServer/1',
          queryFields: ['anp_ubpo'],
          categoryField: 'anp_cate',
        }),
      },
      {
        id: 'concesiones-mineras',
        name: 'Concesiones Mineras',
        description: 'Distribución de concesiones mineras por tipo de actividad y estado operativo.',
        chartType: 'column',
        layer: new LayerEntity({
          name: 'Concesiones mineras',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://geocatmin.ingemmet.gob.pe/arcgis/rest/services/SERV_CATASTRO_MINERO/MapServer/0',
          categoryField: 'LEYENDA',
          queryFields: ['DEPA'],
        }),
      },
    ])
  }
}
